import React from 'react'
import {connect} from 'react-redux'
import {Button, Col, Divider, Form, Input, message, Row, Select, Skeleton, Spin, Typography} from 'antd'

import '../../asset/less/NewPieces.css'
import ApplyFormErrorMessage from '../../component/apply/ApplyFormErrorMessage'
import Checkbox from 'antd/lib/checkbox/Checkbox'
import {withRouter} from 'react-router'
import {postNotification} from "../../api/notifications";
import {getAllArtistNames} from "../../api/artistNames";
import {ArrowLeftOutlined, EditOutlined} from "@ant-design/icons";
import RichTextEditor from "../../component/base/RichTextEditor";
import {convertToHTML} from "draft-convert";
import HttpError from "../../component/base/HttpError";
import {is_admin_user} from "../../app/role";

const {TextArea} = Input

const {Option} = Select
const {Title} = Typography

@connect((state) => ({
    id: state.user.info.id,
    userId: state.user.info.userId,
    email: state.user.info.email,
    role: state.user.info.role,
    artists: state.artist.artists
}))
class NewNotificationAdmin extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.bodyText = React.createRef()
        this.state = {
            modalVisible: false,
            artists: [],
            notifications: [],
            initBody: null,
            loading: false,
            selectAllRecipients: false
        }
    }

    componentDidMount() {
        if (is_admin_user(this.props)) {
            getAllArtistNames().then((response) => {
                const artists = response.data
                this.setState({
                    artists: artists.map((artist) => ({
                        id: artist.user_id,
                        name: artist.name
                    }))
                })
            })
        }
    }

    onFinish = (values) => {
        const bodyEditor = this.bodyText.current.state.editorState
        let html = null
        if (bodyEditor.getCurrentContent().hasText()) {
            html = convertToHTML(bodyEditor.getCurrentContent())
            console.log(html)
        }

        const recipientIDs = values.recipients
        let param = {
            title: values.title,
            message: values.message,
            body: html,
            user: this.props.id,
            receiver: this.state.selectAllRecipients ? this.state.artists.map((artist) => artist.id) : recipientIDs,
        }
        this.setState({loading: true})
        let request = postNotification(param)
        request.then((response) => {
            message.success('Notifications sent').then(() => {
            })
        }).catch((error) => {
            HttpError(error)
        }).finally(() => {
            this.setState({loading: false})
        })
    }

    onFinishFailed = ({values, errorFields, outOfDate}) => {
        this.setState({validateError: errorFields})
        window.scrollTo(0, 0)
        window.scrollTop = 0
    }

    render() {
        const layer1Style = {
            width: '100%',
            height: 320,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
        }

        function getBodyEditLayout(ins) {
            let style1 = ins.state.loading ? {height: 0, display: 'none'} : {}

            return (
                <div>
                    {ins.state.loading && (
                        <Row style={{padding: 24}}>
                            <Col span={24} style={{...layer1Style, height: 362}}>
                                <Skeleton style={{height: 320}} paragraph={{
                                    rows: 8,
                                }} active/>
                            </Col>
                        </Row>
                    )}
                    <div style={style1}>
                        <RichTextEditor ref={ins.bodyText} toLoad={ins.state.initBody}/>
                    </div>
                </div>
            )
        }

        return (
            <Spin size='large' spinning={this.state.loading}>
                <Title>{this.is_new ? 'New' : 'Update'} Notification</Title>
                <Divider/>
                <ApplyFormErrorMessage error={this.state.validateError}/>
                <Form
                    layout='vertical' name='Notification' id='notificationForm'
                    labelCol={{span: 6}}
                    wrapperCol={{span: 14, offset: 1}}
                    colon={false}
                    ref={this.formRef}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name='title'
                        label='Title'
                        rules={[
                            {
                                required: true,
                                message: 'Please input the title of the notification'
                            }
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        name='message'
                        label='Short Message'
                        rules={[
                            {
                                required: false,
                                message: 'Please input the short message for the notification'
                            }
                        ]}
                    >
                        <TextArea autoSize={{minRows: 1, maxRows: 2}}/>
                    </Form.Item>
                    <Form.Item>
                        <Row gutter={[24, 24]}>
                            <Col span={24}>
                                <Divider orientation='left'>
                                    Full Notification Message
                                </Divider>
                            </Col>
                            <Col xs={24} xl={24}>
                                {getBodyEditLayout(this)}
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item name='selectAllRecipients' valuePropName='checked'>
                        <Checkbox
                            onChange={() =>
                                this.setState({
                                    selectAllRecipients: !this.state.selectAllRecipients
                                })
                            }
                        >
                            Select all recipients
                        </Checkbox>
                    </Form.Item>
                    {!this.state.selectAllRecipients && (
                        <Form.Item
                            name='recipients'
                            label='Recipients'
                            rules={[
                                {
                                    required: true,
                                    validator: async (_, recipients) => {
                                        if (!recipients) {
                                            return Promise.reject(new Error('Must have at least one recipient'))
                                        }
                                    }
                                }
                            ]}
                        >
                            <Select
                                mode='multiple'
                                showSearch
                                optionFilterProp='label'
                                placeholder='Enter name'
                                options={this.state.artists.map((artist) => ({
                                    value: artist.id,
                                    label: artist.name
                                }))}
                            />
                        </Form.Item>
                    )}
                    <Col xs={18}
                         sm={16}
                         md={16}
                         lg={14}
                         xl={14}
                         xll={12}
                         style={{
                             display: 'flex',
                             alignItems: 'row',
                             gap: 4,
                             width: '100%',
                             justifyContent: 'space-evenly',
                             marginLeft: '10%',
                             marginRight: 'auto'
                         }}>
                        <div>
                            <Button block size='large' onClick={this.props.history?.goBack}>
                                <ArrowLeftOutlined/>
                                <span style={{fontSize: 14}}>Back</span>
                            </Button>
                        </div>
                        <div>
                            <Button block type='primary' size='large' htmlType='submit'>
                                <EditOutlined/>
                                <span style={{fontSize: 14}}>Create notification</span>
                            </Button>
                        </div>
                    </Col>
                </Form>
            </Spin>
        )
    }
}

export default withRouter(NewNotificationAdmin)
